import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=1bcf8d2b&scoped=true&lang=pug&"
import script from "./PartnerList.vue?vue&type=script&lang=ts&"
export * from "./PartnerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf8d2b",
  null
  
)

export default component.exports